module.exports = __webpack_public_path__ + "static/media/step1-test-packaging.8b4dcca6.png";